import { createGlobalStyle } from 'styled-components';
import BlissProRegularTtf from '../assets/fonts/BlissPro-Regular.ttf';
import BlissProRegularEot from '../assets/fonts/BlissPro-Regular.eot';
import BlissProRegularWoff from '../assets/fonts/BlissPro-Regular.woff';
import SourceSansProSvg from '../assets/fonts/SourceSansPro-Regular.svg';
import SourceSansProEot from '../assets/fonts/SourceSansPro-Regular.eot';
import SourceSansProTtf from '../assets/fonts/SourceSansPro-Regular.ttf';
import SourceSansProWoff from '../assets/fonts/SourceSansPro-Regular.woff';
import SourceSansProWoff2 from '../assets/fonts/SourceSansPro-Regular.woff2';

export default createGlobalStyle`
    @font-face {
        font-family: 'BlissPro';
        src: local('BlissPro'),
        url(${BlissProRegularTtf}) format('truetype'),
        url(${BlissProRegularEot}),
        url(${BlissProRegularWoff}) format('woff');
        font-weight: normal;
        font-style: normal;
    }
    @font-face {
        font-family: 'SourceSansPro';
        src: local('SourceSansPro'),
        url(${SourceSansProTtf}) format('truetype'),
        url(${SourceSansProEot}),
        url(${SourceSansProSvg}),
        url(${SourceSansProWoff}) format('woff'),
        url(${SourceSansProWoff2}) format('woff2');
        font-weight: normal;
        font-style: normal;
    }
`;
